"use strict";

import processInclude from "base/util";

import * as search from "./search/search";
import * as searchBase from "./search/searchBase";
import plpSearchBar from "./search/plpSearchBar";
import * as quickView from "base/product/quickView";

$(function () {
    processInclude(search);
    processInclude(searchBase);
    processInclude(quickView);
    plpSearchBar.init();
});
